import { date } from "./date";

export const dictionaries = { date };
